<template>
  <v-app v-if="isLoggedIn && initialized">
    <div v-shortkey="['ctrl', 'shift', 'q']" @shortkey="toggleDevMode()" style="display: none">GlobalHotKeyCatcher</div>
    <v-app-bar fixed app class="main-menu" tabs color="primary" dark height="50px">
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/">Dashboard</router-link>
      </div>
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/cases/pgt/create">Create PGT case</router-link>
      </div>
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/cases/pgt">Cases</router-link>
      </div>
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/patients">Patients</router-link>
      </div>
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/clients">Clients</router-link>
      </div>
      <div class="main-menu-item">
        <router-link color="blue lighten-5" to="/services">Services</router-link>
      </div>
      <v-spacer></v-spacer>
      <v-tooltip v-if="devMode" bottom>
        <template v-slot:activator="{ on }">
          <v-icon class="mr-1" color="error" v-on="on">fas fa-user-ninja</v-icon>
        </template>
        Extended user mode
      </v-tooltip>
      <v-menu v-model="menu"
              :close-on-content-click="false"
              fixed>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text small>
            {{ user.name }}
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ user.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>

          <v-card-actions>
            <v-btn block text @click="handleLogoutClick">{{ $t("main-menu.logout.title") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <template>
      <file-viewer></file-viewer>
      <vue-snotify></vue-snotify>
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
    </template>
  </v-app>
  <v-app app v-else-if="isLoggedIn && !initialized">
    <v-container class="fill-height">
      <v-row align="center">
        <v-col class="text-center">
          <v-progress-circular indeterminate size="100" color="primary"></v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
  <v-app app v-else-if="!isLoggedIn">
    <template>
      <vue-snotify></vue-snotify>
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
    </template>
  </v-app>
</template>

<script>
import _ from 'lodash'
import {mapActions, mapGetters, mapState} from 'vuex'
import 'moment-duration-format'
import FileViewer from './components/Common/FileViewer/Viewer'

export default {
  name: 'App',
  components: {
    FileViewer
  },
  data() {
    return {
      menu: false
    }
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user,
    }),
    ...mapState({
      initialized: 'initialized',
      devMode: 'devMode'
    }),
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn'
    }),
    language() {
      return _.get(this.user, ['language'], null)
    }
  },
  methods: {
    ...mapActions({
      initApplication: 'initApplication',
      toggleDevMode: 'toggleDevMode',
      logout: 'auth/logout',
      getUserInfo: 'auth/getUserInfo'
    }),
    handleLogoutClick() {
      this.logout()
      this.menu = false
    }
  },
  watch: {
    language: function () {
      this.$i18n.locale = this.language
    }
  },
  async mounted() {
    if (this.isLoggedIn) {
      await this.initApplication()
    } else {
      this.$router.push({path: '/login'})
    }
  },

}
</script>


<style>
.main-menu .main-menu-item {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  font-size: 14px;
  font-weight: 500;
  height: inherit;
  line-height: normal;
  max-width: 264px;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  cursor: pointer;
}

.main-menu .main-menu-item a.router-link-exact-active {
  border-bottom: solid 2px #b3d4fc;
  opacity: 1
}

.main-menu .main-menu-item a {
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  -ms-flex-align: center;
  align-items: center;
  color: inherit;
  display: -ms-flexbox;
  display: flex;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  height: 100%;
  -ms-flex-pack: center;
  justify-content: center;
  max-width: inherit;
  padding: 6px 12px;
  text-decoration: none;
  transition: .3s cubic-bezier(.25, .8, .5, 1);
  user-select: none;
  white-space: normal;
  opacity: .7;
  border-bottom: solid 2px transparent;
}

.main-menu .current-client-title {
  font-size: 13px;
  opacity: .8;
}

.clinic-menu .clinic-menu-item {
}

.clinic-menu .clinic-menu-item.active {
  color: #1976d2;
}

.content-wrapper {
  margin-top: 50px;
}

.code-scanner-status {
  font-size: 31px;
  margin-right: 15px;
}

.blink {
  animation: blink 0.5s steps(5, start) infinite;
  -webkit-animation: blink 0.5s steps(5, start) infinite;
}

@keyframes blink {
  to {
    color: #ff5252;
  }
}

@-webkit-keyframes blink {
  to {
    color: #ff5252;
  }
}

.required-field .v-input__slot {
  background-color: #ddeaef;
}

.cleaner {
  clear: both;
}

.v-textarea textarea {
  line-height: 1.15rem !important;
}

</style>
